export default {
      id: "icon--snowboard-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--snowboard-usage",
      toString: function () {
        return this.url;
      }
    }